module.exports = __webpack_public_path__ + "img/terms-and-conditions-header.53fab55.png";